import 'bootstrap/js/dist/carousel';
import * as money from 'shop/assets/js/utils/money';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import GLightbox from 'glightbox';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Product from 'shop/assets/js/entities/Product';
import ProductVariant from '../../../js/entities/ProductVariant';

GLightbox({ selector: '.glightbox' });

document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', () => {
        let reviewsElement = document.getElementById('product-reviews');
        let scrollTopButton = document.getElementById('scroll-top-button');

        if (reviewsElement.getBoundingClientRect().y < window.innerHeight) {
            scrollTopButton.style.transform = 'none';
        } else {
            scrollTopButton.style.transform = 'translateY(152px)';
        }
    });
});

document.addEventListener('alpine:init', () => {
    Alpine.data('ProductShow', () => ({
        product: null,
        variant: null,
        crossSellingVariant: null,
        giftWrapperVariant: null,
        quantity: null,
        total: null,
        loading: null,
        error: null,
        init() {
            this.product = new Product(JSON.parse(this.$el.getAttribute('data-product')));

            if (window.location.href.indexOf('#') !== -1) {
                this.loadVariantFromUrlAnchor(this.$el.getAttribute('data-variant-code'));
            } else {
                this.loadVariant(this.$el.getAttribute('data-variant-code'));
            }
        },
        loadVariantFromUrlAnchor(fallbackVariantCode) {
            const url = window.location.href;
            const urlOptionValues = url.substring(url.indexOf('#') + 1).split(',');
            let urlVariantCode = null;

            urlOptionValues.forEach(function (value) {
                if (/^\d{8}$/.test(value)) {
                    urlVariantCode = value;
                }
            });

            if (urlVariantCode) {
                this.loadVariant(urlVariantCode);

                return;
            }

            // Primero buscamos una variante sellable para evitar que "findVariantByOptions"
            // nos devuelva una variante equivalente deshabilitada.
            let variant = this.product.findSellableVariantByOptions(urlOptionValues);
            if (!variant) {
                variant = this.product.findVariantByOptions(urlOptionValues);
            }

            if (variant) {
                this.loadVariant(variant.code);
            } else {
                this.loadVariant(fallbackVariantCode);
            }
        },
        loadVariant(variantCode) {
            this.variant = this.product.findVariantByCode(variantCode);
            this.crossSellingVariant = null;
            this.giftWrapperVariant = null;
            this.quantity = this.getInitialQuantity();
            this.loadVariantImages();
            this.updateUrlAnchor();
            this.updateTotal();
            this.thumbnailsNavigationVisibility(true);

            document.dispatchEvent(
                new CustomEvent('ProductShow_Variant_PostLoad', {
                    detail: {
                        variant: this.variant,
                    },
                })
            );
        },
        getInitialQuantity() {
            if (!this.variant.isSellable) {
                return 0;
            }

            if (this.variant.minimumOrderQuantity) {
                return this.variant.minimumOrderQuantity;
            }

            return 1;
        },
        updateUrlAnchor() {
            if (this.variant.optionValues.length > 0) {
                const baseUrl = location.protocol + '//' + location.host + location.pathname + location.search;
                const newURL = `${baseUrl}#${this.variant.optionValues.join(',')}`;
                const newTitle = null;
                const newState = {};
                window.history.replaceState(newState, newTitle, newURL);
            }
        },
        loadVariantImages() {
            document.querySelectorAll(`#variant-images-${this.variant.code} .carousel-wrapper img`).forEach((img) => {
                img.removeAttribute('loading');
            });
        },
        increaseQuantity() {
            this.quantity += 1;
            this.updateTotal();

            document.dispatchEvent(
                new CustomEvent('ProductShow_IncreaseQuantity_Click', {
                    detail: {
                        variant: this.variant,
                        quantity: this.quantity,
                    },
                })
            );
        },
        decreaseQuantity() {
            this.quantity -= 1;
            this.updateTotal();
        },
        selectQuantity(quantity) {
            this.quantity = quantity;
            this.updateTotal();
        },
        getCrossSellingItem(type) {
            switch (type) {
                case 'pdp_turbo':
                    return this.crossSellingVariant;
                case 'pdp_gift_wrapper':
                    return this.giftWrapperVariant;
            }
        },
        setCrossSellingItem(type, variant = null) {
            switch (type) {
                case 'pdp_turbo':
                    this.crossSellingVariant = variant;
                    break;
                case 'pdp_gift_wrapper':
                    this.giftWrapperVariant = variant;
                    break;
            }
        },
        toggleActiveCrossSellingItem(type) {
            let variant = new ProductVariant(JSON.parse(this.$el.getAttribute('data-variant')));
            let crossSellingItem = this.getCrossSellingItem(type);

            if (crossSellingItem && crossSellingItem.code === variant.code) {
                this.setCrossSellingItem(type);
            } else {
                this.setCrossSellingItem(type, variant);
            }

            this.updateTotal();
        },
        updateTotal() {
            const variantPrice = this.variant.price;

            this.total = money.format(
                variantPrice * this.quantity +
                    this.getCrossSellingItemTotalPrice('pdp_turbo') +
                    this.getCrossSellingItemTotalPrice('pdp_gift_wrapper')
            );
        },
        getCrossSellingItemTotalPrice(type) {
            let crossSellingItem = this.getCrossSellingItem(type);

            if (!crossSellingItem) {
                return 0;
            }

            if (this.quantity > crossSellingItem.stock && crossSellingItem.isTracked) {
                return crossSellingItem.price * crossSellingItem.stock;
            }

            return crossSellingItem.price * this.quantity;
        },
        addToCart() {
            this.error = null;
            this.loading = true;

            const url = this.$el.getAttribute('data-add-to-cart-url');
            const formData = this.getFormData();
            const cartModalContainer = document.getElementById('cart-modal-container');
            const cartWidgetContainer = document.getElementById('cart-widget-container');
            const addToCartModalUrl = cartModalContainer.dataset.addToCartModalUrl;
            const cartWidgetUrl = cartModalContainer.dataset.cartWidgetUrl;

            document.dispatchEvent(
                new CustomEvent('ProductShow_AddToCart_Click', {
                    detail: {
                        variant: this.variant,
                        crossSellingVariant: this.crossSellingVariant,
                        quantity: this.quantity,
                    },
                })
            );

            $.post(url, formData)
                .then(() => {
                    let modalUrl = new URL(addToCartModalUrl);
                    let variantCodes = this.variant.code;

                    if (this.crossSellingVariant !== null) {
                        variantCodes += `,${this.crossSellingVariant.code}`;
                    }

                    if (this.giftWrapperVariant !== null) {
                        variantCodes += `,${this.giftWrapperVariant.code}`;
                    }

                    modalUrl.search = new URLSearchParams({
                        variantCodes: variantCodes,
                        quantity: this.quantity,
                    }).toString();

                    this.getView(modalUrl).then((response) => {
                        if (response) {
                            cartModalContainer.innerHTML = response;

                            if (this.isDesktop()) {
                                const modalComponent = new Modal('#modal-cart');
                                modalComponent.show();

                                document.getElementById('modal-cart').addEventListener('shown.bs.modal', (event) => {
                                    this.initiateOpacityTransition(event.target);
                                });
                            } else {
                                const offcanvasComponent = new Offcanvas('#offcanvas-cart');
                                offcanvasComponent.show();

                                document.getElementById('offcanvas-cart').addEventListener('shown.bs.offcanvas', (event) => {
                                    this.initiateOpacityTransition(event.target);
                                });
                            }

                            document.dispatchEvent(
                                new CustomEvent('CrossSellModal_Show', {
                                    detail: {
                                        variant: this.variant,
                                    },
                                })
                            );
                        }
                    });

                    let widgetUrl = new URL(cartWidgetUrl);
                    widgetUrl.search = new URLSearchParams({ template: 'widget' }).toString();

                    this.getView(widgetUrl).then((response) => {
                        if (response) {
                            cartWidgetContainer.innerHTML = response;
                        }
                    });
                })
                .catch((error) => {
                    document.dispatchEvent(new CustomEvent('ProductShow_AddToCart_Error'));

                    const errorMessage = this.extractErrorMessage(error);

                    this.error = errorMessage;

                    this.logError(formData, error, errorMessage);

                    this.$refs.productTitle.scrollIntoView({ behavior: 'smooth' });
                })
                .always(() => (this.loading = false));
        },
        initiateOpacityTransition(targetElement) {
            targetElement.querySelectorAll('.transition-opacity').forEach((element) => {
                element.classList.remove('opacity-0');
            });
        },
        getFormData() {
            const formData = {
                sylius_add_to_cart: {
                    cartItem: {
                        quantity: this.quantity,
                    },
                },
            };

            if (this.product.type === 'configurable') {
                formData.sylius_add_to_cart.cartItem.variant = this.variant.code;
            }

            if (this.crossSellingVariant) {
                formData.cross_sell_variant_code = this.crossSellingVariant.code;
            }

            if (this.giftWrapperVariant) {
                formData.gift_wrapper_variant_code = this.giftWrapperVariant.code;
            }

            return formData;
        },
        extractErrorMessage: function (error) {
            if (error?.responseJSON?.errors?.errors?.length > 0) {
                return error.responseJSON.errors.errors.shift();
            } else if (error instanceof TypeError) {
                return error.message;
            } else {
                return 'Lo sentimos, ha ocurrido un error. Por favor, inténtelo de nuevo.';
            }
        },
        logError: function (formData, error, errorMessage) {
            console.error('[AddToCartError]', {
                payload: JSON.stringify(formData, null, 4),
                response: JSON.stringify(error?.response, null, 4),
                data: JSON.stringify(error?.response?.data, null, 4),
                error: JSON.stringify(error, null, 4),
                error_message: errorMessage,
            });
        },
        isMobileDevice() {
            return window.matchMedia('(max-width: 992px)').matches;
        },
        sendStockNotification() {
            this.stockNotificationLoading = true;
            this.stockNotificationSuccess = false;
            this.stockNotificationError = false;

            fetch(this.stockNotificationUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                    product_id: this.product.data.id,
                    email: this.email,
                }),
            })
                .then((response) => {
                    if (response.ok) {
                        this.stockNotificationSuccess = true;

                        document.dispatchEvent(
                            new CustomEvent('ProductShow_StockNotificationForm_Submit', {
                                detail: {
                                    price: this.variant.price / 100,
                                },
                            })
                        );
                    } else {
                        this.stockNotificationError = true;
                    }
                })
                .catch((error) => {
                    console.error('Request failed:', error);
                })
                .finally(() => {
                    this.stockNotificationLoading = false;
                });
        },
        thumbnailsNavigationVisibility(waitForImagesLoaded = false) {
            const wrapperElement = document.getElementById('variant-thumbnails-' + this.variant.code);
            const thumbnailsElement = wrapperElement.querySelector('.carousel-thumbnails');
            const prevButton = wrapperElement.querySelector('.prev-button');
            const nextButton = wrapperElement.querySelector('.next-button');
            const images = [...wrapperElement.querySelectorAll('img')];

            if (waitForImagesLoaded) {
                Promise.all(images.map((image) => new Promise((resolve) => (image.onload = resolve)))).then(() => {
                    this.handleThumbnailsPrevButtonVisibility(thumbnailsElement, prevButton);
                    this.handleThumbnailsNextButtonVisibility(thumbnailsElement, nextButton);
                });
            } else {
                this.handleThumbnailsPrevButtonVisibility(thumbnailsElement, prevButton);
                this.handleThumbnailsNextButtonVisibility(thumbnailsElement, nextButton);
            }
        },
        handleThumbnailsPrevButtonVisibility(thumbnailsElement, prevButton) {
            if (thumbnailsElement.scrollTop === 0) {
                prevButton.classList.add('invisible');
            } else {
                prevButton.classList.remove('invisible');
            }
        },
        handleThumbnailsNextButtonVisibility(thumbnailsElement, nextButton) {
            if (
                (thumbnailsElement.scrollTop !== 0 &&
                    thumbnailsElement.offsetHeight + thumbnailsElement.scrollTop >= thumbnailsElement.scrollHeight - 1) ||
                thumbnailsElement.scrollHeight <= thumbnailsElement.offsetHeight
            ) {
                nextButton.classList.add('invisible');
            } else {
                nextButton.classList.remove('invisible');
            }
        },
        isDesktop() {
            return window.matchMedia('screen and (min-width:992px)').matches;
        },
        getView(url) {
            return fetch(url, {
                method: 'GET',
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    return response.text();
                })
                .catch((error) => {
                    console.error('Request failed:', error);
                });
        },
    }));
});

Alpine.plugin(intersect);

Alpine.start();
